import apibase from './baseAPI';

const search = async (userAccessType) => {
    const params = {
        userAccessType: userAccessType
    }

    const url = `/navigationAccess/search`;
    const result = await apibase.post(url, params);
    return result.data;
};

export default {
    search: search,
}